class WdCartDrawerCoupon extends HTMLElement {
  #abortController = null;

  connectedCallback() {
    this.#bind();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  #bind() {
    this.#bindRemoveButtons();
    this.#bindCouponForm();
  }

  #bindCouponForm() {
    const toggle = this.querySelector(".wd-cart-drawer-coupon__toggle");
    const formWrap = this.querySelector(".wd-cart-drawer-coupon__form");
    const form = this.querySelector(".wd-cart-drawer-coupon__form-inner");
    const closeBtn = this.querySelector(".wd-cart-drawer-coupon__close");
    const input = this.querySelector(".wd-cart-drawer-coupon__input");

    if (!toggle || !formWrap || !form) return;

    toggle.addEventListener("click", () => this.#openForm(toggle, formWrap, input));
    closeBtn?.addEventListener("click", () =>
      this.#closeForm(toggle, formWrap, input),
    );
    form.addEventListener("submit", (event) => this.#applyDiscount(event, input));
  }

  #bindRemoveButtons() {
    this.querySelectorAll(".wd-cart-drawer-coupon__remove").forEach((button) => {
      button.addEventListener("click", (event) => this.#removeDiscount(event));
    });
  }

  #openForm(toggle, formWrap, input) {
    formWrap.hidden = false;
    formWrap.classList.remove("hidden");
    toggle.setAttribute("aria-expanded", "true");
    toggle.classList.add("hidden");
    this.#hideError();
    input?.focus();
  }

  #closeForm(toggle, formWrap, input) {
    formWrap.hidden = true;
    formWrap.classList.add("hidden");
    toggle.setAttribute("aria-expanded", "false");
    toggle.classList.remove("hidden");
    if (input) input.value = "";
    this.#hideError();
  }

  #hideError() {
    const error = this.querySelector(".wd-cart-drawer-coupon__error");
    if (!error) return;
    error.textContent = "";
    error.classList.add("hidden");
  }

  #showError(message) {
    const error = this.querySelector(".wd-cart-drawer-coupon__error");
    if (!error) return;
    error.textContent = message;
    error.classList.remove("hidden");
  }

  #existingDiscounts() {
    return (this.dataset.discountCodes || "")
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
  }

  #refreshDrawer(data) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer || typeof cartDrawer.renderContents !== "function") return;

    cartDrawer.renderContents(
      {
        sections: data.sections,
        item_count: data.item_count,
      },
      false,
    );

    if (cartDrawer.isOpen && typeof setTabindex === "function") {
      setTabindex(cartDrawer.toggleEelements(), "0");
    }
  }

  async #updateDiscounts(discountCodes) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    const body = JSON.stringify({
      discount: discountCodes.join(","),
      sections: ["cart-drawer", "cart-icon-bubble"],
      sections_url: window.location.pathname,
    });

    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body,
      signal: this.#abortController.signal,
    });

    return response.json();
  }

  async #applyDiscount(event, input) {
    event.preventDefault();

    if (!(input instanceof HTMLInputElement)) return;

    const code = input.value.trim();
    if (!code) return;

    const existing = this.#existingDiscounts();
    if (existing.some((item) => item.toLowerCase() === code.toLowerCase())) {
      return;
    }

    const applyBtn = this.querySelector(".wd-cart-drawer-coupon__apply");
    applyBtn?.setAttribute("disabled", "disabled");
    this.#hideError();

    try {
      const data = await this.#updateDiscounts([...existing, code]);
      const discountEntry = (data.discount_codes || []).find(
        (entry) =>
          entry.code.toLowerCase() === code.toLowerCase() &&
          entry.applicable === false,
      );

      if (discountEntry) {
        this.#showError("*הקוד אינו תקין");
        input.value = "";
        return;
      }

      this.#refreshDrawer(data);
    } catch (error) {
      if (error?.name !== "AbortError") {
        this.#showError("*הקוד אינו תקין");
      }
    } finally {
      applyBtn?.removeAttribute("disabled");
      this.#abortController = null;
    }
  }

  async #removeDiscount(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const row = button.closest("[data-discount-code]");
    const code = row?.dataset.discountCode;
    if (!code) return;

    const remaining = this.#existingDiscounts().filter(
      (item) => item.toLowerCase() !== code.toLowerCase(),
    );

    button.setAttribute("disabled", "disabled");

    try {
      const data = await this.#updateDiscounts(remaining);
      this.#refreshDrawer(data);
    } catch (error) {
      if (error?.name !== "AbortError") {
        button.removeAttribute("disabled");
      }
    } finally {
      this.#abortController = null;
    }
  }
}

if (!customElements.get("wd-cart-drawer-coupon")) {
  customElements.define("wd-cart-drawer-coupon", WdCartDrawerCoupon);
}
